import React, { useState,useEffect } from 'react';

import './style.css';
import BackIcon from '../../Assets/Icons/BackIcon';
import NavbarCustom from '../../Components/NavbarCustom';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useBuyPackages } from "../../APIContext/BuyPackagesContext";

export const VerifyPayment = () => {
  const { verifyPaymentCheck } = useBuyPackages();
  const location = useLocation();

  useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('session_id');
        // console.log("URL id:", id);

        if (id) {
            (async () => {
                try {
                    await verifyPaymentCheck(id);
                } catch (error) {
                    console.error("Error fetching package details:", error);
                }
            })();
        }
    }, [location.search]);
 

  return (
    <>
      <NavbarCustom />
      <div className="verify-payment-container">

            <div className="loading-card" data-loader="3">
                
                <div className="card-content">
                    <div className="loader-3">
                        <div className="spinner">
                            <div className="spinner-ring"></div>
                            <div className="spinner-ring"></div>
                            <div className="spinner-ring"></div>
                        </div>
                        <div className="spinner-text black-text-clip text-center">Verifying your payment</div>
                    </div>
                </div>
            </div>
      </div>
    </>
  );
};
